import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {take} from 'rxjs/operators';
import {LoanSteps, NewLoansService} from "../new-loans.service";
import {Subscription} from "rxjs";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";

@Component({
    selector: 'brightside-web-loan-intro',
    templateUrl: './loan-intro.component.html',
    styleUrls: ['./loan-intro.component.css'],
    standalone: false
})
export class LoanIntroComponent {

  sub = new Subscription();

  currentStep: LoanSteps;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private newLoansSvc: NewLoansService,
    private faCreateSvc: FinancialAccountsCreationService,
  ) {
    this.sub.add(
      this.newLoansSvc.currentStep.subscribe(
        step => {
          this.currentStep = step;
        }
      )
    );
  }

  routeUser() {
    if (this.currentStep === LoanSteps.AUTOSAVE) {
      this.faCreateSvc.advanceStep(AccountCreationSteps.COMPLETED);
      this.router.navigate(['../autosave-select'],{ relativeTo: this.route });
    } else {
      this.newLoansSvc.setStep(LoanSteps.HIGHLIGHTS);
      this.router.navigate(['../highlights'],{ relativeTo: this.route });
    }
  }
  goHome() {
    this.router.navigate(['home']);
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
